import { trpc } from "@blis/trpc/react";

import { InstrumentsTable } from "../components/instruments/InstrumentsTable";
import { Section } from "../components/Section";

export function InstrumentsPage() {
  const { data } = trpc.admin.instrument.list.useQuery();
  return (
    <>
      <Section.Title>Instruments</Section.Title>
      <InstrumentsTable instruments={data} />
    </>
  );
}
